import styled from 'styled-components';

import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { ActionBar } from '@dreryk/react-components';

import { patientTranslationKeys } from '../translations';

import { PatientAssociateModalOpener } from './patientAssociate/PatientAssociateModalOpener';

const ActionButton = styled(ActionBar.PrimaryButton)`
   &:first-letter {
      text-transform: uppercase;
   }
`;

type PatientUnconfirmedAssociateActionProps = {
   readonly unconfirmedPatient: PatientSimple;
};

export const PatientUnconfirmedAssociateAction = (props: PatientUnconfirmedAssociateActionProps): JSX.Element => {
   return (
      <PatientAssociateModalOpener unconfirmedPatient={props.unconfirmedPatient}>
         {({ openModal }) => (
            <ActionButton
               testId={'patientAssociate'}
               label={patientTranslationKeys.unconfirmed.associateWithExistingPatient}
               onClick={openModal}
            />
         )}
      </PatientAssociateModalOpener>
   );
};
